import React from 'react';
import { Box } from '@chakra-ui/react';
import { OverviewTable } from 'routes/travelRequestsOverview/OverviewTable/OverviewTable';
import { useAuth } from 'components/Auth/AuthProvider';

export const OverviewByApprover = (): JSX.Element => {
  const { hasAccess } = useAuth();
  return (
    <Box as="div">
      <OverviewTable role={hasAccess() ? 'approver' : undefined} />
    </Box>
  );
};
